import React from 'react'

export const TermsAndConditionsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">
      <path
        fill="#000"
        d="M40.156 14.531L29.22 3.594c-.313-.313-.625-.469-1.094-.469H12.5A3.134 3.134 0 009.375 6.25v37.5a3.134 3.134 0 003.125 3.125h25a3.134 3.134 0 003.125-3.125V15.625c0-.469-.156-.781-.469-1.094zM28.125 6.875l8.75 8.75h-8.75v-8.75zM37.5 43.75h-25V6.25H25v9.375a3.134 3.134 0 003.125 3.125H37.5v25z"
      ></path>
      <path
        fill="#000"
        d="M15.625 34.375h18.75V37.5h-18.75v-3.125zm0-9.375h18.75v3.125h-18.75V25z"
      ></path>
    </svg>
  )
}
